function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0v75h43.75L75 56.25V0H12.5z",
  fill: "#EFEEEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.25 56.25V75L75 56.25H56.25z",
  fill: "#ABABAB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 75h18.75V56.25L37.5 75z",
  fill: "#DEDEDD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 18.75v21.875h50V18.75H0z",
  fill: "#ccc"
});

var SvgUnknown = function SvgUnknown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnknown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unknown.7ee42471.svg";
export { ForwardRef as ReactComponent };